import { useState } from 'react';
import useForm from '../../../hooks/useForm';
import {
  BodyBox,
  BodyBoxTitle,
  AccountInformationForm,
  AccountInformationFormGroup,
  AccountInformationMessageError,
  AccountInformationMessageSuccess,
  AccountInformationLabel,
  AccountInformationFormControl,
  ButtonAccountInformation,
  AccountInformationSpinner,
} from './Profile.Style';

export const AccountInformation = ({
  user,
  updateProfileWithoutPush,
  setUserContext,
}) => {
  const [status, setStatus] = useState({ success: '', error: '' });
  const [loading, setLoading] = useState(false);

  const { values, handleChange } = useForm({
    initialValues: {
      email: user.email,
      name: user.name,
      phone_number: user.phone_number,
      news_organization: user.news_organization,
    },
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ success: '', error: '' });

    if (!values.name || !values.news_organization) {
      setStatus({
        success: '',
        error: 'Name and News Organization are required fields',
      });
      return;
    }

    try {
      const updatedUser = {
        ...user,
        name: values.name,
        phone_number: values.phone_number,
        news_organization: values.news_organization,
      };

      const result = await updateProfileWithoutPush(updatedUser);

      if (result === true) {
        setUserContext('no');
        setStatus({
          success: 'Account Information Updated Successfully',
          error: '',
        });
      }
    } catch (error) {
      setStatus({ success: '', error: 'Failed to update account information' });
    } finally {
      setLoading(false);
    }
  };

  const formFields = [
    { name: 'name', label: 'Name', disabled: false, required: true },
    { name: 'email', label: 'Email', disabled: true, required: true },
    {
      name: 'phone_number',
      label: 'Phone Number',
      disabled: false,
      required: false,
    },
    {
      name: 'news_organization',
      label: 'Name of News Organization',
      disabled: false,
      required: true,
    },
  ];

  return (
    <div>
      <BodyBox>
        <div>
          <BodyBoxTitle>
            ACCOUNT INFORMATION
          </BodyBoxTitle>
		  <small>Please provide your full name and affiliated news organization below.</small>
        </div>

        <form onSubmit={handleSubmit} aria-label="Account Information Form">
          {status.error && (
            <AccountInformationMessageError role="alert">
              {status.error}
            </AccountInformationMessageError>
          )}
          {status.success && (
            <AccountInformationMessageSuccess role="status">
              {status.success}
            </AccountInformationMessageSuccess>
          )}

          <AccountInformationForm>
            {formFields.map(({ name, label, disabled, required }) => (
              <AccountInformationFormGroup key={name}>
                <AccountInformationLabel htmlFor={name}>
                  {label}{' '}{required && <span aria-hidden="true">*</span>}
                </AccountInformationLabel>
                <AccountInformationFormControl
                  id={name}
                  name={name}
                  type="text"
                  value={values[name]}
                  onChange={handleChange}
                  disabled={disabled}
				  required={required}
                  aria-required={required}
                  aria-label={label}
                />
              </AccountInformationFormGroup>
            ))}
          </AccountInformationForm>

          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <ButtonAccountInformation
              type="submit"
              aria-label="Update Account Information"
              disabled={loading}
            >
              {loading ? (
                <AccountInformationSpinner />
              ) : (
                'Update Information'
              )}
            </ButtonAccountInformation>
          </div>
        </form>
      </BodyBox>
    </div>
  );
};
